import * as React from "react"
import { SVGProps } from "react"

export function LowFareIcon(props: SVGProps<SVGSVGElement>) {
    return(
        <svg
            width={16}
            height={10}
            viewBox='0 0 16 10'
            xmlns='http://www.w3.org/2000/svg'
            {...props}
        >
                <path
                    d='M11 9.5L12.7175 7.7825L9.0575 4.1225L6.0575 7.1225L0.5 1.5575L1.5575 0.5L6.0575 5L9.0575 2L13.7825 6.7175L15.5 5V9.5H11Z'
                    fill='currentColor'
                />
        </svg>
    )
}